import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InaLeRoux from "../Images/InaLeRoux.jpeg"; // Update path if needed
import ReactGA from "react-ga4";


export const HealthInsurance = () => {
    ReactGA.initialize("G-ECGH6LJ63Y");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    return (
        <>
            {/* Page Banner */}

            <Container
                fluid
                style={{
                    background: 'linear-gradient(135deg, #1e1e3f 0%, #3a275e 50%, #ffcc00 100%)',
                    color: '#ffffff',
                    padding: '4rem 2rem',
                    position: 'relative',
                    textAlign: 'center',
                    overflow: 'hidden',
                }}
            >
                {/* Optional Overlay for a polished effect */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        zIndex: 1,
                    }}
                />

                {/* Header Content */}
                <div style={{ position: 'relative', zIndex: 2 }}>
                    <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '1rem' }}>
                        Health Insurance
                    </h1>
                    <p style={{ fontSize: '1.25rem', maxWidth: '700px', margin: '0 auto', color: '#f0f0f0' }}>
                        Your health is your greatest asset — let us help you protect it with expert guidance.
                    </p>
                </div>
            </Container>

            {/* Broker Support Section */}
            <Container className="my-5">
                <Row className="align-items-center">
                    <Col lg={7}>
                        <h2 style={{ fontSize: '2rem', fontWeight: '600', color: '#1e1e3f' }}>Why Choose a Broker for Your Health Insurance?</h2>
                        <p style={{ fontSize: '1.1rem', marginTop: '1rem' }}>
                            Navigating health insurance on your own can be overwhelming. That’s where we come in.
                            With access to multiple providers and in-depth knowledge of the industry, our brokers take the hassle out of healthcare planning.
                        </p>
                        <ul style={{ fontSize: '1rem', marginTop: '1rem', paddingLeft: '1.25rem' }}>
                            <li>We compare multiple quotes to find the best value for your needs</li>
                            <li>Explain all your options in clear, simple terms</li>
                            <li>Support you during claims — we deal with the paperwork, so you don’t have to</li>
                            <li>Provide unbiased recommendations based on your lifestyle and budget</li>
                            <li>Stay with you year after year as your personal health insurance partner</li>
                        </ul>
                        <p style={{ fontSize: '1.1rem', marginTop: '1rem' }}>
                            Whether you need individual coverage, family protection, or help navigating medical aid options,
                            we’re here to make it easier, faster, and more rewarding.
                        </p>
                    </Col>

                    {/* Contact Card */}
                    <Col lg={5} className="mt-5 mt-lg-0">
                        <Card
                            style={{
                                borderRadius: '15px',
                                boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.15)',
                                padding: '2rem',
                                textAlign: 'center',
                                maxWidth: '400px',
                                margin: '0 auto',
                                width: '100%',
                            }}
                        >
                            <Card.Body>
                                <div
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        borderRadius: '50%',
                                        overflow: 'hidden',
                                        margin: '0 auto',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <img
                                        src={InaLeRoux}
                                        alt="Broker"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
                                <h3 style={{ fontSize: '1.5rem', margin: '1rem 0 0.5rem 0', fontWeight: '600' }}>Ina le Roux</h3>
                                <p style={{ fontSize: '1rem', color: '#555' }}>
                                    Personalised health care advice. Contact us for a free quote.
                                </p>
                                <p style={{ fontSize: '1rem', color: '#1e1e3f' }}>
                                    <FontAwesomeIcon icon={faPhone} /> 071 182 8492 <br />
                                    <FontAwesomeIcon icon={faEnvelope} /> admin@logosbrokers.co.za
                                </p>
                                <Button
                                    variant="primary"
                                    href="https://wa.me/711828492"
                                    style={{ marginTop: '1rem' }}
                                >
                                    Message on WhatsApp
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
